import { FC } from 'react';

import { Button, Flex, HStack, rem, Text } from '@bonusly/design-system';
import { useRecognizeURL } from '@bonusly/url';

import { BugRecorder } from './bug-recorder';

export const SpoofingWarning: FC = () => {
	return (
		<Flex
			bgColor="yellow.50"
			data-testid="spoofing-warning"
			py={rem(18)}
			paddingInline={{ base: '0.75rem', xs: '1.5rem' }}
			margin="0 auto"
			alignItems="center"
			justifyContent="space-between"
			position="sticky"
			top={0}
			zIndex={1000}
		>
			<Flex alignItems="center">
				<Text display="inline" color="yellow.700" fontSize="md" fontWeight="normal" lineHeight={6} margin={0}>
					<Text as="span" fontWeight="semibold" fontSize="md">
						Warning!
					</Text>{' '}
					You are currently in spoofing mode and at risk for modifying customer data.
				</Text>
			</Flex>
			<HStack spacing={2}>
				<BugRecorder variant="banner" />
				<Button
					as="a"
					href={useRecognizeURL('/super_admin/spoof/stop_spoofing')}
					bgColor="grayAlpha.100"
					color="gray.800"
					size="sm"
					fontSize="md"
					px={4}
					py={1}
					borderRadius={rem(8)}
					overflow="hidden"
					_focus={{ border: 'none' }}
					_hover={{ bgColor: 'grayAlpha.100', cursor: 'pointer' }}
					_active={{ bgColor: 'grayAlpha.100' }}
				>
					Stop spoofing
				</Button>
			</HStack>
		</Flex>
	);
};
